import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  createCheckoutSession,
  createPortalSession,
  fetchBillingStatus,
  fetchInvoices,
  updateOverage,
  type BillingStatus,
  type InvoiceInfo,
} from '../services/billing';

export const billingKeys = {
  root: ['billing'] as const,
  status: () => [...billingKeys.root, 'status'] as const,
  invoices: () => [...billingKeys.root, 'invoices'] as const,
};

export const useBillingStatus = () =>
  useQuery<BillingStatus>(billingKeys.status(), fetchBillingStatus, {
    retry: false,
  });

export const useCreateCheckout = () => {
  return useMutation(createCheckoutSession);
};

export const useCreatePortal = () => {
  return useMutation(createPortalSession);
};

export const useInvoices = () =>
  useQuery<{ invoices: InvoiceInfo[] }>(billingKeys.invoices(), () =>
    fetchInvoices(),
  );

export const useUpdateOverage = () => {
  const client = useQueryClient();
  return useMutation(updateOverage, {
    onSuccess: () => {
      client.invalidateQueries(billingKeys.status());
    },
  });
};
